    class VatSwitch extends HTMLElement {
      constructor() {
        super();
          this.showVat;
          this.vatRate = 0.21;
          this.priceElements;
          this.toggle = this.querySelector('input[type="checkbox"]');
          this.salesTaxIncl = this.dataset.inclSalesTax === 'true' ? true : false;
        }

        connectedCallback() {
          this.priceElements = document.querySelectorAll('[data-vat-price]');
          this.showVat = localStorage.getItem('show-vat') === 'true' ? true : false;
          this.updatePrices();
          
          this.toggle.checked = this.showVat;
          this.toggle.addEventListener('change', () => this.toggleVisibility());

          // Observe dynamic DOM changes
          this.observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
              for (const node of mutation.addedNodes) {
                if (node.nodeType === 1 && (node.matches('[data-vat-price]') || node.querySelector('[data-vat-price]'))) {
                  this.priceElements = document.querySelectorAll('[data-vat-price]');
                  this.updatePrices();
                  break;
                }
              }
            }
          });

          this.observer.observe(document.body, { childList: true, subtree: true });
        }
  
        updatePrices() {
          this.priceElements.forEach((priceElement) => {
            const basePrice = priceElement.dataset.vatPrice;
            const taxable = priceElement.dataset.vatTaxable === 'true' ? true : false;
            
            let priceIncl;
            let priceExcl;

            if (this.salesTaxIncl) {
              priceIncl = basePrice;
              priceExcl = priceIncl / (1 + this.vatRate);
            } else {
              priceExcl = basePrice;
              priceIncl = priceExcl * (1 + this.vatRate);
            }
            if (taxable) {
              priceElement.innerText = money(this.showVat ? priceIncl : priceExcl);
            } else {
              priceElement.innerText = money(priceExcl);
            }
          });
        }
  
        toggleVisibility() {
          this.showVat = !this.showVat;
          console.log(this.showVat)
          localStorage.setItem('show-vat', this.showVat);
          this.updatePrices();
        }

      }
      customElements.define('vat-switch', VatSwitch);

  /**
  * Converts a number to the configured money format
  * 
  * @param price
  * @param app
  */
  
  function money(price, app = false) {
    if (price) {
        var euroPrice = price / 100;
        var formattedPrice = euroPrice.toLocaleString('nl-NL', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        var priceMoney = '';

        switch (shopCurrency) {
          default:
            priceMoney = formattedPrice;
        }

        priceMoney = priceMoney.replace(/\s/g, '');
    } else {
        var priceMoney = '';
    }
    return priceMoney;
  }
